import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type AiPrompt } from '../../entity/api/aiprompt';
import { createBasicStoreState } from './basic-store';

type TModel = AiPrompt;

type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'ai-prompts' }
  )
);
